import React,{useEffect} from 'react';
import styled from 'styled-components';
import Link from '../elements/link';
import { CONSTS } from '../elements/_constants';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { setCurrentCategory, setSubCategoriesStatus, setMenuCategory } from '../../store/categories/functions';
import { Category } from '../../store/categories/types';
import { logOut, setMenuStatus } from '../../store/base/functions';
import { Chart } from '../../store/charts/types';
import { fetchCharts } from '../../store/charts/functions';
import { UserInterface } from '../../store/base/types';

type navigationProps = {
    className?: string,
    parentCategories?:number[],
    categories:Category[],
    onSetCurrentCategoryId: Function,
    onSetMenuCategory: Function,
    onToggleSubCategories: Function,
    onLogOut: Function,
    onSetMenuStatus: Function,
    isSubCategoriesOpen: boolean,
    currentCategoryId: number,
    currentPathName: string,
    charts: Chart[],
    onFetchCharts :Function
    menuCategoryId: number,
    user: UserInterface
}
const MainNavComponent = (props: navigationProps) => {//TODO: There is a problem in toggling between parents quickly
    // props.onFetchCharts();
    const isCurrentPath = (path: string)=> {
        return props.currentPathName == path || props.currentPathName == path+"/"
    }
    
    return (
        <div className={props.className}>
            <MainNavItem 
                title="داشبورد"
                to="/"
                onClick={()=>{props.onSetCurrentCategoryId(0);props.onSetMenuCategory(0);props.onSetMenuStatus(false);props.onToggleSubCategories(false)}}
                iconClassName="icon-icons8-dashboard"
                isActive={isCurrentPath("/") && props.currentCategoryId == 0 && props.menuCategoryId == 0}
                />

            
            {props.parentCategories && props.parentCategories.map(
                (parent,k)=>
                props.categories &&
                <MainNavItem
                    key={k}
                    title={props.categories[parent].title}
                    onClick={()=>{
                        props.onSetMenuCategory(props.categories && props.categories[parent].id);
                        props.onToggleSubCategories(props.categories && (props.categories[parent].id == props.currentCategoryId) ? !props.isSubCategoriesOpen : true);
                    }}
                    isActive={props.categories[parent].id == props.menuCategoryId}
                    iconClassName={props.categories[parent].title.includes('مدیر') ? "icon-icons8-manager" : "icon-icons8-administrative_tools"}/> //TODO: It's not currect
            )}
            
            {props.charts && props.charts.map(chart => (
                <MainNavItem 
                    title={chart.title}
                    to={`/charts/${chart.id}`}
                    onClick={()=>props.onSetMenuStatus(false)}
                    isActive={isCurrentPath(`/charts/${chart.id}`) && props.currentCategoryId == 0}
                    iconClassName="icon-icons8-info"/>
            ))}
            
            <MainNavItem 
                title="اطلاعات آزمایشگاه"
                to="/laboratory"
                onClick={()=>props.onSetMenuStatus(false)}
                isActive={isCurrentPath("/laboratory") && props.currentCategoryId == 0}
                iconClassName="icon-icons8-info"/>
            {props.user && props.user.is_admin &&
            <MainNavItem
                title="کاربران سیستم"
                to="/users/"
                onClick={()=>props.onSetMenuStatus(false)}
                isActive={isCurrentPath("/users") && props.currentCategoryId == 0}
                iconClassName="icon-icons8-conference_call"/>
            }
            
            <MainNavItem
                title="انبار"
                to="/store/"
                onClick={()=>props.onSetMenuStatus(false)}
                isActive={isCurrentPath("/store") && props.currentCategoryId == 0}
                iconClassName="icon-icons8-double_left"/>
            
            <div className="responsive-menu-items">
                <MainNavItem 
                    title="پروفایل کاربری"
                    to="/profile/"
                    onClick={()=>props.onSetMenuStatus(false)}
                    isActive={isCurrentPath("/profile") && props.currentCategoryId == 0}
                    iconClassName="icon-icons8-user"/>
                <MainNavItem 
                    title="خروج"
                    onClick={()=>props.onLogOut()}
                    iconClassName="icon-icons8-logout_rounded_up"/>
            </div>
        </div>
    )
}
const MainNavItem = (props: {className?: string,iconClassName?: string,isActive?:boolean,title?: string,onClick?: any,to?:string}) => {
    return (
        <Link to={props.to && props.to} className={`noselect ${props.className} main-nav-item ${props.isActive && 'active'}`} onClick={props.onClick && props.onClick}>
            <div className={`_icon ${props.iconClassName}`}></div>
            <div className="_title">{props.title}</div>
        </Link>
    )
}

const MainNav = styled(MainNavComponent)`
    width: ${props => props.isSubCategoriesOpen ? '50px' : '300px'};
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
        width: ${props => props.isSubCategoriesOpen ? '65px' : '100%'};
    }
    transition: ease width .3s;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 0 0 0 1px rgba(63,63,68,0.05);
    overflow: hidden;
    * {
        box-sizing: border-box;
    }
    .responsive-menu-items {
        display: none;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            display: block;
        }
    }
    .main-nav-item {
        overflow: hidden;
        width: 300px;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            width: 100vw;
        }
        min-height: 49px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        color: ${CONSTS.colors.greyDarker};
        cursor: pointer;
        transition: all .2s ease;
        &.active {
            background: ${CONSTS.colors.primary};
            color: white;
        }
        &:hover:not(.active) {
            color: ${CONSTS.colors.primary};
            background: ${CONSTS.colors.primaryLight};
        }
        ._icon {
            width: 50px;
            @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
                width: 65px;
            }
            height: 100%;
            font-size: 22px;
            text-align: center;
        }
        ._title {
            padding-left: 10px;
            font-size: 14px;
            font-family: ${CONSTS.fonts.primary.medium};
        }
    }
`
const mapStateToProps = (state: AppState) => ({
    categories          : state.categories.items,
    charts              : state.charts.items,
    parentCategories    : state.categories.parents,
    currentCategoryId   : state.categories.currentCategoryId,
    isSubCategoriesOpen : state.categories.isSubCategoriesOpen,

    currentPathName     : state.base.path,
    menuCategoryId      : state.categories.menuCategoryId,
    user                : state.base.user
});
   
const mapDispatchToProps = (dispatch:any) => {
    return {
        onSetCurrentCategoryId  : (id: number)      =>{
            dispatch(setCurrentCategory(id));
        },
        onToggleSubCategories   : (open: boolean)   =>{
            dispatch(setSubCategoriesStatus(open));
        },
        onFetchCharts           : () => dispatch(fetchCharts()),
        onLogOut                : ()                =>{
            dispatch(logOut());
        },
        onSetMenuStatus   : (open: boolean)   =>{
            dispatch(setMenuStatus(open));
        },
        onSetMenuCategory  : (categoryId: number)      =>{
            dispatch(setMenuCategory(categoryId));
        },
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MainNav);

// export default MainNav;